// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".reorder-notification[data-v-0427f2ff]{background:#fdefef;margin:16px auto;padding:16px;max-width:736px;border-radius:8px}.reorder-notification h3[data-v-0427f2ff]{color:#dc5353;font-weight:700;font-size:1.2rem;text-align:center;margin-bottom:1rem}", ""]);
// Exports
module.exports = exports;
